import { IScopeOption } from './gql'
import { ISettingRule } from './hooks/usePrepSettings'

// why: the standing value and the schedule table state the same rules list, and
// two formatters would drift the moment one is edited.
const formatRuleSummary = (
  rules: ISettingRule[],
  scopeById: Record<number, IScopeOption>,
): string =>
  rules
    .map((rule) => {
      if (rule.locationId !== null) return `Store ${rule.value}%`
      if (rule.locationGroupId === null) return `All ${rule.value}%`
      const scope = scopeById[rule.locationGroupId]
      return `${scope?.scopeName ?? `Group ${rule.locationGroupId}`} ${
        rule.value
      }%`
    })
    .join(' · ')

export default formatRuleSummary
